import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import BackButton from 'redesign/components/atoms/Buttons/BackButton'
import CloseButton from 'redesign/components/atoms/Buttons/CloseButton'
import FlexContainer from 'redesign/components/atoms/wrappers/flex-container'
import HeaderLabel from 'redesign/components/molecules/HeaderLabel'
import Header from 'redesign/components/organisms/Header'
import { DEFAULT_CONTENT_GAP, START_CONTENT_GAP } from './constants'
import type { SideMenuNestedHeaderProps } from './types'

const SideMenuNestedHeader: React.FC<SideMenuNestedHeaderProps> = ({
  isDrawer,
  onClose,
  titleKey,
  onGoBack,
  endContent,
}) => {
  const { t } = useFavurTranslation()

  return (
    <Header
      skipAdaptivePadding
      startContent={
        <FlexContainer gap={isDrawer ? DEFAULT_CONTENT_GAP : START_CONTENT_GAP}>
          <BackButton onGoBack={onGoBack} />
        </FlexContainer>
      }
      middleContent={<HeaderLabel mainText={t(titleKey)} />}
      endContent={
        <FlexContainer gap={isDrawer ? DEFAULT_CONTENT_GAP : START_CONTENT_GAP}>
          {endContent}
          {isDrawer && <CloseButton onClick={onClose} />}
        </FlexContainer>
      }
    />
  )
}

export default SideMenuNestedHeader
